import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lista" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control has-icons-left has-icons-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Editar tarefa", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "descricaoTarefa",
  class: "label"
}, " Descrição ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormularioTarefa = _resolveComponent("FormularioTarefa")!
  const _component_TarefaComponent = _resolveComponent("TarefaComponent")!
  const _component_BoxComponent = _resolveComponent("BoxComponent")!
  const _component_modalComponent = _resolveComponent("modalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormularioTarefa, { onAoSalvarTarefa: _ctx.salvarTarefa }, null, 8, ["onAoSalvarTarefa"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "Digite para filtrar",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtro) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filtro]
          ]),
          _hoisted_4
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tarefas, (tarefa, index) => {
        return (_openBlock(), _createBlock(_component_TarefaComponent, {
          key: index,
          dados: tarefa,
          onRemoverTarefa: ($event: any) => (_ctx.removerTarefa(index)),
          onAoTarefaClicada: ($event: any) => (_ctx.selecionarTarefa(tarefa))
        }, null, 8, ["dados", "onRemoverTarefa", "onAoTarefaClicada"]))
      }), 128)),
      _withDirectives(_createVNode(_component_BoxComponent, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sem_tarefas')), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.listaEstaVazia]
      ])
    ]),
    (_ctx.tarefaSelecionada != null)
      ? (_openBlock(), _createBlock(_component_modalComponent, {
          key: 0,
          mostrar: _ctx.tarefaSelecionada != null
        }, {
          cabecalho: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fecharModalEdicao()))
            })
          ]),
          corpo: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tarefaSelecionada.descricao) = $event)),
                id: "descricaoTarefa"
              }, null, 512), [
                [_vModelText, _ctx.tarefaSelecionada.descricao]
              ])
            ])
          ]),
          rodape: _withCtx(() => [
            _createElementVNode("button", {
              class: "button is-success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alterarTarefa()))
            }, "Salvar alterações"),
            _createElementVNode("button", {
              class: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fecharModalEdicao()))
            }, "Cancelar")
          ]),
          _: 1
        }, 8, ["mostrar"]))
      : _createCommentVNode("", true)
  ], 64))
}